import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowLeftUpCircle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-left-up-circle"><path d="M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.75 14.25V8.75H14.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M15.2501 15.25L9.43066 9.43054" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowLeftUpCircle;
